'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";

export default function () {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            ok: '=?myOk',
            pagination: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            loading: '=myLoading',
            openEditSupport: '=openEditSupport',
            search: '=search',
            refresh: '=refresh'
        },
        controllerAs: 'vm',
        controller: ['$scope', '$utils', '$timeout', 'StatusService', 'Notification', '$security', 'OrgService', 'ModalService',
            function ($scope, $utils, $timeout, StatusService, Notification, $security, OrgService, ModalService) {
                $scope.getValue = $utils.getValue;
                $scope.getStatusDisplayName = StatusService.getDisplayName;

                // endregion

                // region Watchers

                // endregion

            }]
    };
}
